import React from 'react';
import './App.css';
import Collection from './pages/Collection';
import Labels from './pages/Labels';
import Explore from './pages/Explore';
import New from './pages/New';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ChangePassword from './pages/ChangePassword';
import History from './pages/History';
import { AppProvider } from './context/AppContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import { Toaster } from 'react-hot-toast';
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <Router>
      <AppProvider>
        <div className="min-h-screen bg-violet-400">
          <Navbar />
          <main className="pt-16">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="/change-password" element={
                <PrivateRoute>
                  <ChangePassword />
                </PrivateRoute>
              } />
              <Route path="/history" element={
                <PrivateRoute>
                  <History />
                </PrivateRoute>
              } />
              <Route path="/" element={
                <PrivateRoute>
                  <New />
                </PrivateRoute>
              } />
              <Route path="/labels" element={
                <PrivateRoute>
                  <Labels />
                </PrivateRoute>
              } />
              <Route path="/explore" element={
                <PrivateRoute>
                  <Explore />
                </PrivateRoute>
              } />
              {/* Collection (previously Home) */}
              <Route path="/collection" element={
                <PrivateRoute>
                  <Collection />
                </PrivateRoute>
              } />
            </Routes>
          </main>
          <Toaster position="top-center" />
        </div>
        <Analytics />
      </AppProvider>
    </Router>
  );
}

export default App;
